import { css } from '@emotion/react'
import styles from '@mathflat/common/style'

const {
  colors: { gray, blue },
} = styles

const S = {
  CheckboxButton: css`
    display: flex;
    input {
      + label {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;

        border: 1px solid ${gray.$400};
        border-radius: var(--Radius-Circle);
        color: ${gray.$700};
        cursor: pointer;
      }
      :checked + label {
        border-color: ${blue.$200};
        background: ${blue.$100};
        color: ${blue.$300};
      }
    }

    &.disabled > label {
      cursor: default;
      color: ${gray.$600};
      border-color: ${gray.$200};
      background: #fff;
    }
  `,
}

export default S
